import type { SchemaBuilderFieldProviderProps } from "./schema-builder-field.type";
import type { PropsWithChildren } from "react";

import { SchemaBuilderFieldContext } from "./schema-builder-field.context";
import { useSchemaBuilderFieldContextValue } from "./schema-builder-field.hook";

export const SchemaBuilderFieldProvider = ({
  children,
  ...props
}: PropsWithChildren<SchemaBuilderFieldProviderProps>) => {
  const value = useSchemaBuilderFieldContextValue(props);

  return (
    <SchemaBuilderFieldContext.Provider value={value}>
      {children}
    </SchemaBuilderFieldContext.Provider>
  );
};
